import UnderlinedFieldLabel from './UnderlinedFieldLabel';

export default UnderlinedFieldLabel;
